module.exports = __webpack_public_path__ + "img/fille-ecriture.021bb09c.jpg";